export default __webpack_public_path__ + "static/media/srisailamVisitFour.76691c9e.jpg";